import { Button, ButtonProps } from "@mui/material";
import { useRef } from "react";

type CsvFileButtonProps = Omit<ButtonProps, "onClick" | "onChange"> & {
  children: React.ReactNode;
  accept?: string;
  "data-testid"?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const UploadFileButton = ({ children, onChange, accept, ...props }: CsvFileButtonProps) => {
  const fileInputRef = useRef<any>(null);
  const handleButtonClick = () => {
    fileInputRef?.current.click();
  };
  const resetInputValue = (event: React.MouseEvent<HTMLInputElement>) => {
    const element = event.currentTarget;
    element.value = "";
  };
  return (
    <Button
      sx={{ width: "137px", height: (theme) => theme.spacing(6) }}
      color="primary"
      variant="outlined"
      onClick={handleButtonClick}
      {...props}
    >
      {children}
      <input
        ref={fileInputRef}
        type="file"
        hidden
        data-testid={props["data-testid"] || "uploadCasesCsvButton"}
        accept={accept || "text/csv"}
        onChange={onChange}
        onClick={resetInputValue}
      />
    </Button>
  );
};
export default UploadFileButton;
